import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';

import { ProfileService } from '../service/profile.service';
import { Profile } from 'src/app/core/models/profile';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {

  public form: FormGroup;

  public openModalEdit = false;
  public showModalCV = false;
  public bannerImg: string;
  public profileImg: string;
  public profileDefault = 'https://bucketsquadcrm.s3.amazonaws.com/default_images/profile_default.jpg';
  private docBody = document.querySelector('body');

  constructor(
    private formBuilder: FormBuilder,
    private service: ProfileService
  ) { }

  ngOnInit(): void {
    this.initForm();
    this.initialData();
  }

  public initialData() {
    this.service.getPerfil().subscribe(profile => this.populatingForm(profile));
  }

  private initForm() {
   this.form = this.formBuilder.group({
      id: [null],
      banner_image_url: [null],
      profile_image_url: [null],
      name: [null],
      nickname: [null],
      is_editable: [false],
      state: [null],
      country: [null],
      phone: [null],
      alternative_phone: [null],
      email: [null],
      biography: [''],
      designacao_tecnica: [null],
      technical_designation: [],
      creci: [null],
      company: [null],
      languages: [[]],
      profile_url: [null]
    });
  }

  public validatorControls(params: string, subParams: string): boolean {
    if (this.form.get(params).value && this.form.get(subParams).value) {
      return true;
    }
    return false;
  }

  public validators = (): boolean => {
    const data = Object.assign({}, this.form.controls);
    if (data.technical_designation.value && data.creci.value && data.company.value) {
      return true;
    }
    return false;
  }

  public showModalEdit() {
    this.docBody.setAttribute('style', 'overflow: hidden');
    document.querySelectorAll('div.app-container').forEach((x: HTMLElement) => {
      x.style.overflow = 'hidden';
      x.classList.add('removed-scroll');
    });
    this.openModalEdit = true;
  }

  public openCard() {
    this.docBody.setAttribute('style', 'overflow: hidden');
    this.showModalCV = true;
  }

  public closeCardModal(event: boolean) {
    this.docBody.setAttribute('style', 'overflow: auto');
    this.showModalCV = event;
  }

  public closeModalEdit(event: boolean) {
    this.docBody.setAttribute('style', 'overflow: auto');
    document.querySelectorAll('div.app-container').forEach((x: HTMLElement) => {
      x.style.overflow = 'inherit';
      if (x.classList.contains('removed-scroll')) {
        x.classList.remove('removed-scroll');
      }
    });

    this.openModalEdit = event;
    this.service.findByName(this.form.get('nickname').value).subscribe((profile: Profile) => {
      this.populatingForm(profile);
    });
  }

  private populatingForm(profile) {
    for (const key in profile) {
      if (profile.hasOwnProperty(key)) {
        this.form.get(key).patchValue(profile[key]);
        this.profileImg = this.form.get('profile_image_url').value ? this.form.get('profile_image_url').value : this.profileDefault;
      }
    }
  }
}
